import { render, staticRenderFns } from "./CommandAssistantIntroduction.vue?vue&type=template&id=4c2870a7&"
import script from "./CommandAssistantIntroduction.vue?vue&type=script&lang=js&"
export * from "./CommandAssistantIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistantIntroduction.vue?vue&type=style&index=0&id=4c2870a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports